import { BarChartOutlined, BarsOutlined, ClockCircleOutlined, DoubleLeftOutlined, DoubleRightOutlined, EnvironmentOutlined, EnvironmentTwoTone, GlobalOutlined, LaptopOutlined, LockFilled, NotificationOutlined, NotificationTwoTone, SearchOutlined, ShopOutlined, SoundOutlined, TrophyOutlined, UnlockFilled } from '@ant-design/icons';
import { Layout as AntdLayout, Badge, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GoogleBizRoutes from '../../../routing/GoogleBizRoutes';
import { useAuth } from '../../../store/AuthContext/AuthContext';
import './SideMenu.scss';
import { ROLES, useIsAuthorized, useModuleActive } from '../../pages/common/roles/Roles';

const { Sider, Content } = AntdLayout;
const grey = '#bab6b6';
const black = "#051235";

export const InfoLayout = () => {

	const isAuthorized = useIsAuthorized();
	//const isModuleActive = useModuleActive();
	const location = useLocation();
	const pathName = location.pathname;
	const { collapsed, setCollapsed } = useAuth();
	const isModuleActive = useModuleActive();
	const { t } = useTranslation();		

	return (
		<AntdLayout>
			<Sider width={140} className='container-space' collapsed={collapsed} collapsible={true} trigger={null}>
				<aside>
					<nav>
						<ul>
							<Link to="/negocios/locales">
								<li className={`${(pathName == '/negocios/locales') ? 'item-selected' : 'item-no-selected' }${` item-space`}`}>
									<div>
										<ShopOutlined style={{color: (pathName == '/negocios/locales') ? black : grey }} className='icon-menu-item'/>
										<span className={`${(pathName == '/negocios/locales') ? 'selected' : 'no-selected' }`}>{t('subMenu.info.list')}</span>
									</div>
								</li>
							</Link>							
							{/*!isAuthorized(['ROLE_GUEST_VIEW']) &&  */}
								<Link to="/negocios/web">	
									<li className={`${(pathName == '/negocios/web') ? 'item-selected' : 'item-no-selected' }${` item-space`}`}>
										<div>
										<Badge offset={[10, 0]} count={isModuleActive('WEB_SYNC') ? <UnlockFilled style={{ color: 'green' }} /> : <LockFilled style={{ color: 'crimson' }} />}> 
											<GlobalOutlined style={{color: (pathName == '/negocios/web') ? black : grey }} className='icon-menu-item'/>
										</Badge>
											<span className={`${(pathName == '/negocios/web') ? 'selected' : 'no-selected' }`}>{t('subMenu.info.web')}</span>
										</div>
									</li>
								</Link>
							
							{/*!isAuthorized(['ROLE_GUEST_VIEW']) &&*/}
								<Link to="/negocios/seo">	
									<li className={`${(pathName == '/negocios/seo') ? 'item-selected' : 'item-no-selected' }${` item-space`}`}>
										<div>
											<Badge offset={[10, 0]} count={isModuleActive('COMPETITORS') ? <UnlockFilled style={{ color: 'green' }} /> : <LockFilled style={{ color: 'crimson' }} />}> 
												<TrophyOutlined style={{color: (pathName == '/negocios/seo') ? black : grey }} className='icon-menu-item'/>
											</Badge>
											<span className={`${(pathName == '/negocios/seo') ? 'selected' : 'no-selected' }`}>Competidores</span>
										</div>
									</li>
								</Link>							
							<Link to="/negocios/global">
								<li className={`${(pathName == '/negocios/global') ? 'item-selected' : 'item-no-selected' }${` item-space`}`}>
									<div>
										<BarChartOutlined style={{color: (pathName == '/negocios/global') ? black : grey }} className='icon-menu-item'/>
										<span className={`${(pathName == '/negocios/global') ? 'selected' : 'no-selected' }`}>{t('subMenu.info.stats')}</span>
									</div>
								</li>
							</Link>							
						</ul>
					</nav>
				</aside>
			</Sider>			
			<Content className='container-space'>
				<div>
					<GoogleBizRoutes />
				</div>
			</Content>			
		</AntdLayout>
	)
};